var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"ratio-container",class:_vm.data.staticClass,style:({paddingTop: ((_vm.props.ratio) + "%")})},[_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }